<template>
  <div class="custom-index-view">
    <index-panel
      :collection="`users/${user.uid}/customIndexes`"
      :doc="$route.params.name"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import IndexPanel from './IndexPanel';

export default {
  components: {
    IndexPanel,
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
};
</script>
